import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EvaluationStatusEnum from "./evaluationStatusEnum";
import useNavigateToLoginPageEnv from "./useNavigateToLoginPageEnv";
import Loading from "./loading";

const Begin = ({ updateStatus, updateBeginOrNew }) => {
    const navigateToLoginPageEnv = useNavigateToLoginPageEnv();
    const navigate = useNavigate();
    const { courseCode, assessmentCode } = useParams();
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);

    const handleClick = async () => {
        if (requestLifeCycle) {
            return;
        }
        
        try {
            setRequestLifeCycle(true);
            const response = await fetch( process.env.REACT_APP_EVALUATION_API_URL  + `/begin-first-attempt`, {
                method: "POST",
                credentials: "include",  
                headers: {
                    'Content-Type': "application/json"
                },
                body: JSON.stringify({
                    courseCode: courseCode,
                    assessmentCode: assessmentCode,
                    entryCode: ""
                })
            })
            const data = await response.json();

            // if correct -> go to take page
            if (response.status === 200) {
                localStorage.setItem(assessmentCode, "true");
                localStorage.setItem("didDismissLogging", "false");
                localStorage.setItem('blockPaste', 'true');
                navigate(`/${courseCode}/${assessmentCode}/take-evaluation`);
            // errors that should make it gray
            } else if (response.status === 450 || response.status === 451 || response.status === 455 || response.status === 456) {
                updateStatus(EvaluationStatusEnum.ERROR)
            // go to entry code page
            } else if (response.status === 453) {
                updateStatus(EvaluationStatusEnum.NOT_ENTERED_ENTRY_CODE);
                updateBeginOrNew("first");
            // auth
            } else if (response.status === 401) {
                navigateToLoginPageEnv();
            // catch any other issues
            } else {
                alert("Status Code: " + response.status + " Error: " + data.detail);
                updateStatus(EvaluationStatusEnum.ERROR);
            }
        } catch(error) {
            alert("Error: " + error.message);
            updateStatus(EvaluationStatusEnum.ERROR)
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }
    
    return (
        <>
            {
                requestLifeCycle

                ?

                <>
                    <div className="total-2">
                        <Loading />
                    </div>
                </>

                :

                <div className="top-right-item" onClick={handleClick} style={{ minWidth: "110px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1z"/>
                    </svg>
                    Begin
                </div>

            }
        </>
    );
}

export default Begin;